export type SemanticKpiTone = 'success' | 'warning' | 'danger' | 'info' | 'slate' | 'muted'

export type SemanticBadgeTone = Exclude<SemanticKpiTone, 'muted'>

const TONE_SOLID_CLASS: Record<SemanticBadgeTone, string> = {
 success: 'border-transparent bg-semantic-success-solid text-semantic-success-solid-fg',
 warning: 'border-transparent bg-semantic-warning-solid text-semantic-warning-solid-fg',
 danger: 'border-transparent bg-semantic-danger-solid text-semantic-danger-solid-fg',
 info: 'border-transparent bg-semantic-info-solid text-semantic-info-solid-fg',
 slate: 'border-transparent bg-semantic-slate-solid text-semantic-slate-solid-fg',
}

/** Solid KPI icon well classes for a semantic tone. */
export function semanticKpiIconClass(tone: SemanticKpiTone): string {
 if (tone === 'muted') {
  return TONE_SOLID_CLASS.slate
 }
 return TONE_SOLID_CLASS[tone]
}

/** Solid badge classes — same tokens as KPI icon wells. */
export function semanticBadgeClass(tone: SemanticBadgeTone): string {
 return TONE_SOLID_CLASS[tone]
}

/** Solid surface classes for banners and highlight panels. */
export function semanticSolidSurfaceClass(tone: SemanticBadgeTone): string {
 return TONE_SOLID_CLASS[tone]
}

export type ShiftPaymentVariant = 'cash' | 'instapay' | 'ewallet'

export const SHIFT_PAYMENT_SOLID_TONE: Record<ShiftPaymentVariant, SemanticBadgeTone> = {
 cash: 'success',
 instapay: 'info',
 ewallet: 'slate',
}

export const SEMANTIC_BADGE_CLASS = {
 success: TONE_SOLID_CLASS.success,
 warning: TONE_SOLID_CLASS.warning,
 destructive: TONE_SOLID_CLASS.danger,
 info: TONE_SOLID_CLASS.info,
 neutral: TONE_SOLID_CLASS.slate,
 secondary: TONE_SOLID_CLASS.slate,
} as const

/** Pass through KPI icon classes (solid wells are the canonical style). */
export function resolveKpiIconClass(className?: string): string | undefined {
 return className
}
